import React, { useEffect, useState } from 'react';
import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import './availablePRI.css';
import CheckListNumbers from './CheckListNumbers';

const AvailablePRI = ({
  isOpen,
  onCancel,
  onConfirm,
  data,
  finalSelectedList,
  numberToFilter,
  setSelectedNumbers,
  selectedNumbers,
  isNumberModify,
}) => {
  const [state, setState] = useState(data || {});
  const [selectAll, setSelectAll] = useState(isNumberModify);
  const [selectedList, setSelectedList] = useState([]);
  const [inputState, setInputState] = useState({
    m1: '',
    m2: '',
    m3: '',
    m4: '',
    m5: '',
    m6: '',
    m7: '',
    m8: '',
    m9: '',
    m10: '',
  });
  const handleChange = e => {
    setInputState({ ...inputState, [e.currentTarget.name]: e.currentTarget.value });
  };
  useEffect(() => {
    const joined = Object.values(inputState);
    joined.map((item, index) => {
      if (item === '') {
        joined[index] = '*';
      }
    });
    const finalNumber = joined.join('');
    if (numberToFilter) {
      numberToFilter(finalNumber);
    }
  }, [inputState]);
  useEffect(() => {
    setState(data || {});
  }, [data]);

  const switchButton = (
    <div className="maskField-container-filter">
      <p style={{ marginTop: '15px' }}>Filters: </p>
      <Input
        type="tel"
        name="m1"
        maxLength={1}
        placeholder={'X'}
        className="mask-field-filter"
        onChange={handleChange}
      />
      <Input
        type="tel"
        name="m2"
        maxLength={1}
        placeholder={'X'}
        className="mask-field-filter"
        onChange={handleChange}
      />
      <Input
        type="tel"
        name="m3"
        maxLength={1}
        placeholder={'X'}
        className="mask-field-filter"
        onChange={handleChange}
      />
      <p className="mask-divider-filter">-</p>
      <Input
        type="tel"
        name="m4"
        maxLength={1}
        placeholder={'X'}
        className="mask-field-filter"
        onChange={handleChange}
      />
      <Input
        type="tel"
        name="m5"
        maxLength={1}
        placeholder={'X'}
        className="mask-field-filter"
        onChange={handleChange}
      />
      <Input
        type="tel"
        name="m6"
        maxLength={1}
        placeholder={'X'}
        className="mask-field-filter"
        onChange={handleChange}
      />
      <p className="mask-divider-filter">-</p>
      <Input
        type="tel"
        name="m7"
        maxLength={1}
        placeholder={'X'}
        className="mask-field-filter"
        onChange={handleChange}
      />
      <Input
        type="tel"
        name="m8"
        maxLength={1}
        placeholder={'X'}
        className="mask-field-filter"
        onChange={handleChange}
      />
      <Input
        type="tel"
        name="m9"
        maxLength={1}
        placeholder={'X'}
        className="mask-field-filter"
        onChange={handleChange}
      />
      <Input
        type="tel"
        name="m10"
        maxLength={1}
        placeholder={'X'}
        className="mask-field-filter"
        onChange={handleChange}
      />
    </div>
  );

  const selectedItem = e => {
    if (selectedList.includes(e.value)) {
      const CheckIndex = selectedList.indexOf(e.value);
      selectedList.splice(CheckIndex, 1);
      setSelectedList(selectedList);
      finalSelectedList(selectedList);
      setSelectedNumbers(selectedList);
    } else {
      selectedList.push(e.value);
      setSelectedList(selectedList);
      finalSelectedList(selectedList);
      setSelectedNumbers(selectedList);
    }
  };

  const selectAllNumbers = () => {
    if (selectAll) {
      const allNumber = data?.map(number => number?._id || number.numRef);
      setSelectedList([...allNumber]);
      finalSelectedList([...allNumber]);
      setSelectedNumbers([...allNumber]);
    } else {
      setSelectedNumbers([]);
      setSelectedList([]);
      finalSelectedList([]);
      setSelectedNumbers([]);
    }
  };
  useEffect(() => {
    selectAllNumbers();
  }, [selectAll]);
  useEffect(() => {
    setSelectAll(isNumberModify);
  }, [isNumberModify]);
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader close={switchButton}>
        <p>Available Numbers</p>
        <div className="container select-all">
          <Label check>
            <Input type="checkbox" checked={selectAll} onChange={() => setSelectAll(!selectAll)} />
            {isNumberModify ? 'Unselect All' : 'Select All'}
          </Label>
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="container available">
          <CheckListNumbers
            isNumberModify={isNumberModify}
            selectedItem={selectedItem}
            selectedNumbers={selectedNumbers}
            setSelectedNumbers={setSelectedNumbers}
            checkList={data}
            selectedList={selectedList}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        <Button outline onClick={onCancel}>
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={() => {
            onConfirm(state);
            setSelectedList([]);
            setSelectAll(null);
          }}
        >
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AvailablePRI;
